import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges, ChangeDetectorRef, ViewChild } from '@angular/core'
import { IDropdownOption } from '../../models/dropdown-option.interface'

@Component({
   selector: 'vc-single-select-dropdown',
   standalone: false,
   templateUrl: './single-select-dropdown.component.html',
   styleUrls: ['./single-select-dropdown.component.scss'],
})
export class SingleSelectDropdownComponent implements OnInit, OnChanges {
   @Input() sizeClass: 'v-dropdown-sm' | 'v-dropdown-md' | 'v-dropdown-lg' | 'v-dropdown-full' = 'v-dropdown-md'

   // icon variant on the dropdown itself: v-categoryfilter | v-typefilter | v-sitefilter | v-userfilter | v-defaultfilter
   @Input() variantClass = 'v-defaultfilter'
   @Input() label = ''
   @Input() placeholder = 'Select'
   @Input() optionLabel: 'label' | 'name' | null = null
   @Input() optionValue?: string
   @Input() disabled = false
   @Input() showClear = true
   @Input() required = false

   @Input() items: IDropdownOption[] = []
   @Input() setValue: IDropdownOption
   @Input() selectedItems: IDropdownOption[] = []
   _items: IDropdownOption[] = []
   _setValue: IDropdownOption
   selectedItem: IDropdownOption

   // filtering
   @Input() filter = true
   @Input() filterBy: string = 'label' // 'label,value'
   @Input() filterPlaceholder = 'Search'

   @Output() selectionChange = new EventEmitter<any>()

   @ViewChild('dropdown') dropdown: any

   constructor(private cdr: ChangeDetectorRef) {}

   ngOnInit(): void {
      if (this.items?.includes(this.setValue)) {
         this.selectedItem = this.setValue
      }
   }

   ngOnChanges(changes: SimpleChanges): void {
      if (changes.items?.currentValue) {
         this._items = changes.items?.currentValue
      }
      if (changes.setValue?.currentValue) {
         this._setValue = changes.setValue.currentValue
      }
      if (this._items?.length > 0 && this._setValue) {
         if (!!this.optionValue) {
            // pricing admin - it just wants the id (string)
            this.selectedItem = this._setValue
         } else {
            this.selectedItem = this._items.find((x) => x.id === this._setValue?.id)
         }
      }
   }

   getItemLabel = (item: any): string => {
      return typeof item === 'string' ? item : item.name
   }

   onChange(): void {
      this.selectionChange.emit(this.selectedItem)
   }

   isOptionDisabled = (item: any, i: number) => {
      if (this.selectedItems?.length > 0) {
         return this.selectedItems.find((x) => x && x.id === item.id)
      }
      return false
   }
}
